function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M6,17.086V20H8.917L17.522,11.4,14.606,8.48ZM19.77,9.149a.779.779,0,0,0,0-1.1L17.954,6.232a.779.779,0,0,0-1.1,0L15.43,7.656l2.917,2.917L19.77,9.149Z",
  transform: "translate(-3 -3.003)",
  fill: "#09b0ee"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M0,0H20V20H0Z",
  fill: "none"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "iconfinder_ic_mode_edit_48px_352547",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "storage/static/media/edit.61c84819.svg";
export { SvgComponent as ReactComponent };